import React from "react";

export function NotFoundPage() {
  return <div>404</div>;
}
